import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { deleteExtension } from 'src/api/extensions';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

interface IDeleteExtensionParams {
  brandId: string;
  extensionId: string;
  addonName: string;
}

export const useDeleteExtension = (onSuccess?: () => void) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ brandId, extensionId }: IDeleteExtensionParams) =>
      deleteExtension(brandId, extensionId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.EXTENSIONS, variables.brandId] });
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: `${variables.addonName} has been disconnected.`,
      });
      onSuccess?.();
    },
    onError: (error: Error, variables) => {
      showSnackbar({
        message: error.message || `Unable to disconnect ${variables.addonName}`,
        status: SnackbarStatus.ERROR,
      });
      captureException(error);
    },
  });
};
